import { connect } from 'react-redux';
import AnonymizerToggle from './AnonymizerToggle';
import { getIsAnonymized } from '../../selectors';
import { anonymizeProfiles, deanonymizeProfiles } from '../../actions';

export default connect(
  (state, ownProps) => ({
    isAnonymized: getIsAnonymized(state),
  }),
  (dispatch) => ({
    anonymizeProfiles: () => dispatch(anonymizeProfiles()),
    deanonymizeProfiles: () => dispatch(deanonymizeProfiles()),
  })
)(AnonymizerToggle);
